import { PolicyPage } from "@/components/PolicyPage";

export default function Terms() {
  return <PolicyPage policyType="terms" title="Terms of Use" testid="terms-page" />;
}
